export default {
  "root": "_root_myqn7_1",
  "text": "_text_myqn7_1",
  "icon": "_icon_myqn7_1",
  "--icon-position-end": "_--icon-position-end_myqn7_1",
  "loader": "_loader_myqn7_1",
  "--icon-only": "_--icon-only_myqn7_1",
  "--loading": "_--loading_myqn7_1",
  "--rounded": "_--rounded_myqn7_1",
  "--size-small": "_--size-small_myqn7_1",
  "--size-medium": "_--size-medium_myqn7_1",
  "--size-large": "_--size-large_myqn7_1",
  "--size-xlarge": "_--size-xlarge_myqn7_1",
  "--full-width": "_--full-width_myqn7_1",
  "--variant-faded": "_--variant-faded_myqn7_1",
  "--color-neutral": "_--color-neutral_myqn7_1",
  "--variant-solid": "_--variant-solid_myqn7_1",
  "--highlighted": "_--highlighted_myqn7_1",
  "--color-primary": "_--color-primary_myqn7_1",
  "--color-critical": "_--color-critical_myqn7_1",
  "--color-positive": "_--color-positive_myqn7_1",
  "--color-media": "_--color-media_myqn7_1",
  "--disabled": "_--disabled_myqn7_1",
  "--color-inherit": "_--color-inherit_myqn7_1",
  "--variant-outline": "_--variant-outline_myqn7_1",
  "--variant-ghost": "_--variant-ghost_myqn7_1",
  "--elevated": "_--elevated_myqn7_1",
  "group": "_group_myqn7_1",
  "--color-black": "_--color-black_myqn7_1",
  "--color-white": "_--color-white_myqn7_1",
  "aligner": "_aligner_myqn7_1",
  "--size-small--m": "_--size-small--m_myqn7_1",
  "--size-medium--m": "_--size-medium--m_myqn7_1",
  "--size-large--m": "_--size-large--m_myqn7_1",
  "--size-xlarge--m": "_--size-xlarge--m_myqn7_1",
  "--full-width-true--m": "_--full-width-true--m_myqn7_1",
  "--full-width-false--m": "_--full-width-false--m_myqn7_1",
  "--size-small--l": "_--size-small--l_myqn7_1",
  "--size-medium--l": "_--size-medium--l_myqn7_1",
  "--size-large--l": "_--size-large--l_myqn7_1",
  "--size-xlarge--l": "_--size-xlarge--l_myqn7_1",
  "--full-width-true--l": "_--full-width-true--l_myqn7_1",
  "--full-width-false--l": "_--full-width-false--l_myqn7_1",
  "--size-small--xl": "_--size-small--xl_myqn7_1",
  "--size-medium--xl": "_--size-medium--xl_myqn7_1",
  "--size-large--xl": "_--size-large--xl_myqn7_1",
  "--size-xlarge--xl": "_--size-xlarge--xl_myqn7_1",
  "--full-width-true--xl": "_--full-width-true--xl_myqn7_1",
  "--full-width-false--xl": "_--full-width-false--xl_myqn7_1"
};import "ni:sha-256;-cFNp94_beW7ZoKbmbfREtrbUsB3nR93P1X1mh74gzE";